import * as React from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import genders from 'modules/settings/store/collections/genders'
import legalGenders from 'modules/settings/store/collections/legalGenders'
import type Gender from 'modules/settings/store/models/Gender'

import DeleteModal from './DeleteModal'
import EditModal from './EditModal'
import GenderList from './GenderList'
import NewModal from './NewModal'

type State = { gender: Gender; modal: 'edit' | 'delete' } | { modal: 'new' | 'none' }
type Actions =
  | { type: 'open'; gender: Gender; modal: 'edit' | 'delete' }
  | { type: 'new' }
  | { type: 'close' }

const initialState: State = { modal: 'none' }

function reducer(_state: State, action: Actions): State {
  switch (action.type) {
    case 'open':
      return { gender: action.gender, modal: action.modal }
    case 'new':
      return { modal: 'new' }
    case 'close':
      return initialState
    default:
      throw new Error()
  }
}

const GenderSettings = () => {
  const [state, dispatch] = React.useReducer(reducer, initialState)

  const { loading } = useAsyncData(() => {
    return Promise.all([genders.fetch(), legalGenders.fetch()])
  }, [])

  return (
    <>
      <Section.List
        title={i18n.t('gender_settings.title')}
        illustration="user"
        description={i18n.t('gender_settings.description')}
        action={{
          label: i18n.t('gender_settings.create'),
          onClick: () => dispatch({ type: 'new' }),
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <GenderList
            genders={genders.models}
            onClick={({ modal, gender }) => {
              dispatch({ type: 'open', gender, modal })
            }}
          />
        )}
      </Section.List>

      {state.modal === 'new' && <NewModal onClose={() => dispatch({ type: 'close' })} />}
      {state.modal === 'edit' && (
        <EditModal
          onClose={() => dispatch({ type: 'close' })}
          gender={state.gender}
          legalGendersSelected={legalGenders.findByGender(state.gender)}
        />
      )}
      {state.modal === 'delete' && (
        <DeleteModal onClose={() => dispatch({ type: 'close' })} gender={state.gender} />
      )}
    </>
  )
}

export default observer(GenderSettings)
